export default "__VITE_ASSET__B$GQPftt__"